import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function activate_checkVerification(code) {
  try {
    loginfo();
    return await apiClient.post(`/users/validation/check-code`, {
      code,
    });
  } catch (error) {
    console.error('activate_checkVerification failed.', error);
  }
}

export async function activate_setPassword(code, password) {
  try {
    loginfo();
    return await apiClient.put(`/users/password/activate`, {
      code,
      password,
    });
  } catch (error) {
    console.error('activate_setPassword failed.', error);
  }
}

export async function activate_activateAccount(code) {
  try {
    loginfo();
    return await apiClient.post(`/users/validation/verify-email`, {
      code,
    });
  } catch (error) {
    console.error('activate_activateAccount failed.', error);
  }
}

export async function updateFusionPassword(oldPassword, newPassword) {
  try {
    loginfo();
    return await apiClient.put('/users/password/change', {
      newPassword,
      oldPassword,
    });
  } catch (error) {
    console.error('updateFusionPassword failed.', error);
  }
}

export async function sendResetEmail(email) {
  try {
    loginfo();
    return await apiClient.post('/users/password/reset-link', { email });
  } catch (error) {
    console.error('sendResetEmail failed.', error);
  }
}

export async function updatePasswordWithCode(password, code) {
  try {
    loginfo();
    return await apiClient.put('/users/password/reset', {
      password,
      code,
    });
  } catch (error) {
    console.error('updatePasswordWithCode failed.', error);
  }
}
